define(["jquery", "domReady", "pubsub"], function($, domReady) {
	
	var DEBUG = false;

	var ProductContext = function(productContextContainer) {
		if (!(this instanceof ProductContext)) {
			return new ProductContext(productContextContainer);
		}
		this.$contextContainer = $(productContextContainer);
		var $_firstTrigger = this.$contextContainer.find('.context-trigger-js.active-context-js').first();
		if($_firstTrigger) {
			this._currentProductId = $_firstTrigger.data('productId');
			this._currentPartNumber = $_firstTrigger.data('partNumber');
		}
		if(this._currentProductId) {
			this._manageTriggers();
			this._attachListeners();
		}

		return this;
	};

	ProductContext.prototype = {
		
		_manageTriggers: function() {

			if ( DEBUG ) console.log('_manageTriggers');

			var self = this;
			this.$contextContainer.find('.context-trigger-js').each(function () {
				if($(this).data('productId') != self._currentProductId) {
					$(this).removeClass('active-context-js');
				} else if(!$(this).hasClass('active-context-js')) {
					$(this).addClass('active-context-js');
				}
			});
		},

		_attachListeners: function() {

			if ( DEBUG ) console.log('_attachListeners');
			
			this.$contextContainer.on('click', {self: this}, this._handleContextChange);

		},

		_handleContextChange: function(event, self) {
			
			if ( DEBUG ) console.log('_handleContextChange');
			
			self = self || event.data.self;
			if(!$(event.target).hasClass('context-trigger-js')) {
				return;
			}
			if(event.origCaller && 'click' != event.origCaller) {
				return;
			}
			var _newProductId = $(event.target).data('productId');
			if(!_newProductId || (_newProductId == self._currentProductId)) {
				return;
			}

			self._currentProductId = _newProductId;
			self._currentPartNumber = $(event.target).data('partNumber');
			self._manageTriggers();
			self._toggleComponents();
			self._setProductIdData();
			self.$contextContainer.trigger('PRODUCT_CONTEXT_CHANGED');
			var productFormIndex = $('.product-form-js').index(this.productForm);
			var data = {productFormIndex: productFormIndex};
			$.pubsub('publish', 'product-form.attr.context.changed', data);
		},

		_toggleComponents: function() {
			
			if ( DEBUG ) console.log('_toggleComponents');
			var self = this;
			this.$contextContainer.find('.context-toggle-js').each(function() {
				// do nothing for the product title
				if ( $(this).is('h1') ) {
					return;
				}
				if($(this).data('productId') == self._currentProductId) {
					$(this).removeClass('hide');
					$(this).find('input, select').prop('disabled', false);
					$(this).find('.color-swatches-js .selected').trigger('click', {preventDataLayerPush: true});
				} else if(!$(this).hasClass('hide')) {
					$(this).addClass('hide');
					$(this).find('input, select').prop('disabled', true);
				}
			});

		},

		_setProductIdData: function() {
			
			if ( DEBUG ) console.log('_setProductIdData');

			$(this).data('productId', this._currentProductId);
			this.$contextContainer.find('.context-data-js').data('productId', this._currentProductId);

		}
	};

	domReady(function() {
		
		$('.product-context-js').each(function() {
			var instance = $(this).data('productContext');
			if ( !instance) {
				instance = new ProductContext($(this));
				$(this).data('productContext', instance);
			}
		});
		
		$(document).on('QUICKSHOP_DISPLAY', function() {
			$('.product-context-js').each(function() {
				if(!$(this).data("productContext")) {
					$(this).data("productContext", new ProductContext($(this)));
				}
			});
		});
	});
	
});